import { IProjectApiCallInfo } from '../../models/IProjectApiCallInfo';
import initialState from '../initialState';
import * as types from './actionTypes.clientCodeRunner';
import * as _ from 'lodash';

const initialStateObj = {
    paramsHistory: initialState.clientCodeRunner.paramsHistory,
};

export default function ClientCodeRunnerReducer(state = initialStateObj, action) {
    switch (action.type) {
        case types.GET_PROJECT_API_HISTORY_OK:
            return {
                ...state,
                paramsHistory: {
                    ...state.paramsHistory,
                    [action.projectId]: [...action.storedHistory],
                },
            };
        case types.REMEMBER_PROJECT_API_PARAMS_OK:
            return {
                ...state,
                paramsHistory: {
                    ...state.paramsHistory,
                    [action.projectId]: [
                        ...(state.paramsHistory[action.projectId] || []),
                        {
                            param: action.param,
                            functionName: action.functionName,
                            result: action.result,
                            projectApiName: action.projectApiName,
                            historyKey: action.historyKey,
                            callTs: Date.now(),
                            callId: action.callId
                        } as never as IProjectApiCallInfo
                    ]
                },
            };
        case types.REMEMBER_PROJECT_API_RESULT_OK:
            return {
                ...state,
                paramsHistory: {
                    ...state.paramsHistory,
                    [action.projectId]: [
                        ...state.paramsHistory[action.projectId].slice(0, action.index),
                        {
                            ...state.paramsHistory[action.projectId][action.index],
                            result: action.result,
                            error: action.error,
                        },
                        ...state.paramsHistory[action.projectId].slice(action.index + 1),
                    ]
                },
            };
        default:
            return state;
    }
}